import gql from 'graphql-tag';

export const FETCH_APPOINTMENT_CONSENT_MESSAGE = gql`
  query ($appointmentId: String!) {
    getFutureAppointmentConsentMessage( appointmentId: $appointmentId ) {
      locale
      consentDialogMessage
      declineMessage
    }
  }
`;
